import { DEFAULT_LANGUAGE } from '../../helpers/constants'
import { mapActions, mapState } from 'vuex'

export default {
  computed: {
    ...mapState('userStates', ['user']),
    ...mapState('languagesStates', [
      'translatedStringLoading',
      'translatedStrings',
    ]),
    currentUserLanguageCode() {
      return `${this.user.language || DEFAULT_LANGUAGE}`.toLowerCase()
    },
    languagesDictionary() {
      const languages = [
        { value: 'en', text: 'English' },
        { value: 'es', text: 'Spanish' },
        { value: 'es-mx', text: 'Spanish (Mexico)' },
      ]

      return languages
    },
  },
  methods: {
    ...mapActions('languagesStates', ['getTranslation', 'getTextToSpeech']),
  },
}
